import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../Services/MasterDataService';
import { BaseComponent } from './BaseComponent';
import { BaseResponse, ErrorResponse } from '../Models/ResponseModels';


@Component({
    selector: 'ErrorSummary',
    templateUrl: './ErrorSummary.html',
})
export class ErrorSummary implements OnInit {
    MainModel: any;
    @Input() ErrorList: Array<ErrorResponse>;

    constructor() {
        this.ErrorList = new Array<ErrorResponse>();
    }

    ngOnInit(): void {

    }
    CheckErrorType(errorCode): string {
        if (errorCode && !(/^ERR\./.test(errorCode)) && (/^ERR\_/.test(errorCode)))
            return 'ERR.'+errorCode;
        else
            return  errorCode;
    }
}
